import countries from "@public/data/country.json";
import { ResponseUserDetail } from "@models/data-contracts";
import { makeFlagEmoji } from "@logics/utils/makeFlagEmoji";

interface BaseUserDataType {
  id?: ResponseUserDetail["id"];
  name?: ResponseUserDetail["nickName"];
  url: ResponseUserDetail["url"];
  national?: ResponseUserDetail["national"];
}

class BaseUserProfileViewModel {
  userId?: number;
  name?: string;
  profileImage: string;
  national?: string;

  /** ex) 🇰🇷 Korea */
  nationalWithFlag?: string;

  constructor(data: BaseUserDataType) {
    this.userId = data?.id;
    this.name = data?.name;
    this.profileImage = data.url;
    this.national = data?.national;
    this.nationalWithFlag = BaseUserProfileViewModel.combineNationalWithFlag(
      data.national,
    );
  }

  private static combineNationalWithFlag(national?: string) {
    if (!national) return "";

    const flagEmoji = makeFlagEmoji(national);
    const countryName = countries[national];

    return `${flagEmoji} ${countryName}`;
  }
}

export default BaseUserProfileViewModel;
